const copyToClipBoard = (event, variable) => {
  event.preventDefault();
  navigator.clipboard.writeText(variable);
};

export { copyToClipBoard };
